<section class="detail404-sec" id="content">
  <div class="container-xl">
      <div class="page-404">
        <div class="detail404">
          <h2>Error</h2>
          <img src="assets/images/page-not-found.png" alt="page-not-found">
          <p class="largeText">Oops! That page can't be found.</p>
          <p>It looks like nothing was found at this location.</p>
          <a class="gotohm" href="/">Go to Home</a>
        </div>
      </div>  
  </div>
</section>